import {useFluxStore} from 'client/framework';
import React from 'react';

import {Banner} from '@albert-io/atomic';
import sessionStore from 'client/Session/SessionStore';

const studentText = 'You did not submit a response for this question.';
const teacherText = 'No response was submitted.';

const IncompletenessBanner = () => {
  const isStudent = useFluxStore(sessionStore, (s) => s.isStudent());

  return (
    <div className='mb-x4'>
      <Banner type={isStudent ? 'negative' : 'neutral'}>
        <Banner.Icon icon={isStudent ? 'times' : 'minus'} />
        {isStudent ? studentText : teacherText}
      </Banner>
    </div>
  );
};

export default IncompletenessBanner;
